import {
    LIST_JUDGES,
    LIST_JUDGES_SUCCESS,
    LIST_JUDGES_ERROR,
    ADD_JUDGES,
    SAVE_JUDGES,
    SAVE_JUDGES_SUCCESS,
    SAVE_JUDGES_ERROR,
    EDIT_JUDGES,
    ENABLE_JUDGES,
    ENABLE_JUDGES_SUCCESS,
    ENABLE_JUDGES_ERROR,
    UPDATE_JUDGES,
    UPDATE_JUDGES_SUCCESS,
    UPDATE_JUDGES_ERROR,
    DELETE_JUDGES,
    DELETE_JUDGES_SUCCESS,
    DELETE_JUDGES_ERROR
} from '../types';

// Cada reducer tiene su propio state
const initialState = {    
    error: null,
    errorSave: null,
    isEdit: false,
    judges: null,
    judgeSelected: null,
    loading: false, 
    loadingSave: false
}


export default function(state = initialState, action) {
    switch(action.type){
        case LIST_JUDGES:
            return {
                ...state,
                loading: true
            }
        case LIST_JUDGES_ERROR:
            return {
                ...state,
                loading: false,
                error: action.payload
            }
        case LIST_JUDGES_SUCCESS:
            return {
                ...state,
                loading: false,
                error: null,
                judges: action.payload
            }
        case ENABLE_JUDGES:
        case SAVE_JUDGES:
        case DELETE_JUDGES:
            return {
                ...state,
                isEdit: false,
                loadingSave: true
            }
        case UPDATE_JUDGES:
            return {
                ...state,
                loadingSave: true
            }
        case ENABLE_JUDGES_ERROR:
        case SAVE_JUDGES_ERROR:
        case UPDATE_JUDGES_ERROR:
        case DELETE_JUDGES_ERROR:
            return {
                ...state,
                loadingSave: false,
                errorSave: action.payload
            }
        case SAVE_JUDGES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                judges: [...state.judges, action.payload]
            }
        case ADD_JUDGES:
            return {
                ...state,
                judgeSelected: null,
                isEdit: false
            }
        case EDIT_JUDGES:
            return {
                ...state,
                judgeSelected: action.payload,
                isEdit: true
            }
        case ENABLE_JUDGES_SUCCESS:
        case UPDATE_JUDGES_SUCCESS:
        case DELETE_JUDGES_SUCCESS:
            return {
                ...state,
                loadingSave: false,
                errorSave: null,
                judges: state.judges.map(judge => 
                    judge.id === action.payload.id ? judge = action.payload : judge
                ),
                judgeselected: null
            }
        default:
            return state;
    }
}